import { PG_FILTER_ALL } from "../components/PalletGroup/pgFilterConstants";

/** Matches backend {@code SpurDisplayStatus} API values. */
export const SPUR_DISPLAY_STATUS = {
  IDLE: "Idle",
  ASSIGNED: "Assigned",
  READY_TO_COMPLETE: "Ready to Complete",
  SUSPENDED: "Suspended",
};

export const SPUR_STATUS_FILTER_OPTIONS = [
  { label: "All Statuses", value: PG_FILTER_ALL },
  { label: SPUR_DISPLAY_STATUS.ASSIGNED, value: SPUR_DISPLAY_STATUS.ASSIGNED },
  { label: SPUR_DISPLAY_STATUS.IDLE, value: SPUR_DISPLAY_STATUS.IDLE },
  { label: SPUR_DISPLAY_STATUS.SUSPENDED, value: SPUR_DISPLAY_STATUS.SUSPENDED },
  {
    label: SPUR_DISPLAY_STATUS.READY_TO_COMPLETE,
    value: SPUR_DISPLAY_STATUS.READY_TO_COMPLETE,
  },
];
